import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import Modal from 'reactstrap/lib/Modal';

import { ClippedContainer } from 'site-modules/shared/components/clipped-container/clipped-container';
import {
  desktopHeader,
  mobileHeader,
} from 'site-modules/shared/components/clipped-container/mask-library/dealership-header';

import './contact-seller-modal.scss';
import { SUCCESS_MODAL_LABEL } from './constants';

export function ContactSellerModal({ isOpen = false, onToggle = noop, children }) {
  return (
    <Modal
      className="contact-seller-modal"
      contentClassName="contact-seller-modal-content rounded-20 overflow-hidden pos-r"
      isOpen={isOpen}
      toggle={onToggle}
      aria-labelledby="contact-seller-modal-label"
    >
      <span className="visually-hidden" id="contact-seller-modal-label">
        {SUCCESS_MODAL_LABEL}
      </span>

      <button
        type="button"
        className="contact-seller-modal-close btn btn-link p-0 pos-a"
        onClick={onToggle}
        aria-label="Close dialog"
      >
        <span className="icon-cross2 text-white size-20" aria-hidden />
      </button>

      <ClippedContainer
        mask={desktopHeader}
        containerClasses="contact-seller-modal-bg w-100 pos-a top-0 left-0 d-none d-md-block"
      />
      <ClippedContainer
        mask={mobileHeader}
        containerClasses="contact-seller-modal-bg w-100 pos-a top-0 left-0 d-md-none"
      />
      <div className="p-1_5 pt-3">
        <div className="bg-white rounded-16 px-2_5 py-2 pos-r contact-seller-modal-card">{children}</div>
      </div>
    </Modal>
  );
}

ContactSellerModal.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.node.isRequired,
};
